// extracted by mini-css-extract-plugin
export default {"item":"lg9FQg7M","columns":"dbjvdn4L"};